import React, { useState } from 'react';
import './AdminLogin.css';
import { httpPost } from '../../http';
import AdminLoginView from './AdminLogin';

import { connect } from 'react-redux';
import AppReducer from '../../redux/reducers/AppReducer';
import AdminReducer from '../../redux/reducers/AdminReducer';
import { doAdminLoginAction } from '../../redux/actions/AdminActions';

const AdminLogin = ({ AdminReducer, history, doAdminLoginAction }) => {

    const [ login, setLogin ] = useState({
        email: '',
        password: '',
    });

    const handleChange = (e) => {
        setLogin({
            ...login,
            [e.target.name]: e.target.value
        });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const res = await doAdminLoginAction({ email: login.email, password: login.password });
        if (res){
            history.push('/admin');
        } else {

        }
    }

    return(
        <AdminLoginView AdminReducer={AdminReducer} login={login} onSubmit={handleSubmit} onChange={handleChange} />
    );
}

const mapStateToProps = ({ AppReducer, AdminReducer }) => {
    return {
        AppReducer,
        AdminReducer
    };
};

const mapDispatchToProps = {
    doAdminLoginAction
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminLogin);